export default __webpack_public_path__ + "static/media/Amulet of the Asshuri.3d2d0dbf.jpg";